import { PaperDocumentTypes } from '@components/modal-manager/templates/download-mx-paper-modal/download-mx-paper-modal';
import { ClassroomId, GroupId } from '@containers/activity-router/data-grid-container/student-list/student-list.types';
import { AssignmentRequestTypes } from '@containers/activity-router/routes/helpers/assignment/route-assignment.types';
import {
    NewCoursesAssignmentResultType
} from '@containers/activity-router/routes/learn/new-courses/new-courses-constants';

// 2 instances. Other is src/services/gateways/combined-assign-gateway/combined-assign-gateway.types.ts
export enum CourseTypes {
    ACTIVITIES_ID = 0,
    SKILL_QUESTS_ID = 1,
    CHALLENGES_ID = 2,
    NEW_COURSES_ID = 4
}

export type CombinedAssignGatewayInitialDataParams = {
    preferredClassroomId: number
    preferredGroupId: number
    authToken: string | null
    preferredCourseType: CourseTypes
    locale: string
};

export type CombinedAssignGatewayClassroomsParams = {
    classroomId: ClassroomId
    groupId: GroupId
    authToken: string | null
};

export type CombinedAssignGatewayAssignmentsDefaultParams = {
    productId: number
    classroomId: ClassroomId
    groupId: GroupId
    authToken: string | null
    assignmentResultType: number
    assignmentRequestType: AssignmentRequestTypes
    usePreviousResultWhenThereIsNoCurrent: boolean
};

export type CombinedAssignGatewayNewCoursesExportParams = {
    productId: number
    classroomId: ClassroomId
    groupId: GroupId
    assignmentResultType: number
    usePreviousResultWhenThereIsNoCurrent: boolean
    studentsSortOrder: number
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayChallengesExportParams = {
    productId: number
    classroomId: ClassroomId
    groupId: GroupId
    assignmentResultType: number
    usePreviousResultWhenThereIsNoCurrent: boolean
    studentsSortOrder: number
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayNewCoursesYearGroupsParams = {
    authToken: string | null
    locale: string
    validYearGroups: Array<number>
};

export type CombinedAssignGatewayNewCoursesAttemptsParams = {
    productId: number
    classroomId: number
    studentUserProfileId: number
    assignmentResultType: NewCoursesAssignmentResultType
    authToken: string | null
    locale: string
    questionSetIds: Array<string>
};

export type CombinedAssignGatewayNewCoursesCourseListParams = {
    courseType: CourseTypes
    yearGroup: number | null
    countryCode: string | null
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayNewCoursesAssignCourseParams = {
    courseType: CourseTypes
    classroomId: ClassroomId
    groupId: GroupId
    courseId: string
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayTeacherNotesExistenceParams = {
    activityId: string
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewaySkillsQuestAssignmentParams = CombinedAssignGatewayAssignmentsDefaultParams & {
    courseId?: number
    courseVersion?: number
};

export type CombinedAssignGatewayDownloadMXPaperParams = CombinedAssignGatewayAssignmentsDefaultParams & {
    paperDocumentTypesSelected: PaperDocumentTypes[]
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayChallengesAttemptsParams = Omit<CombinedAssignGatewayNewCoursesAttemptsParams, 'questionSetIds'> & {
    activityIds: Array<string>
};

export type CombinedAssignGatewayTeacherMultipleNotesExistenceParams = {
    activityIds: Array<string>
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayGetChallengesPlaylistsParams = {
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayChallengesPostManageablePlaylistsParams = {
    authToken: string | null
    locale: string
};

export type CombinedAssignGatewayChallengesDeleteManageablePlaylistsParams = {
    authToken: string | null
    locale: string
    teacherPlaylistId: number
};
